module.exports = __webpack_public_path__ + "media/32.47e5de69.wav";